import { ColDef } from "ag-grid-community";
import { useEffect, useState } from "react";

import Exclamation from "../../../../assets/Exclamation.png";
import True_img from "../../../../assets/baseVersion/True_img.svg";
import False_img from "../../../../assets/baseVersion/False_img.svg";
import debian from "../../../../assets/debian.svg";
import debian_dark from "../../../../assets/debian_dark.svg";
import Not_Applicable from "../../../../assets/baseVersion/NotApplicable.svg";
import PendingReview_img from "../../../../assets/baseVersion/PendingReview.svg";
import Cisco_img from "../../../../assets/baseVersion/cisco.svg";
import Paloalto_img from "../../../../assets/baseVersion/paloalto.svg";
import axiosInstance from "../../../../axios/axios";
import AgGridTable from "../../../../components/table/AgGridTable";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
//  import arista_assets from "../../assets/arista-assets.svg";
import juniper_assets from "../../../../assets/juniper.svg";
import { Box, Typography, useTheme } from "@mui/material";
import Paloalto_dark from "../../../../assets/palaoto_dark.svg";
import AWS_img from "../../../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../../../assets/baseVersion/AWS_DARK.svg"
import arista_dark from "../../../../assets/arista_dark.svg";
import arista_img from "../../../../assets/baseVersion/arista.svg";
import juniper_dark from "../../../../assets/baseVersion/dark_juniper.svg";
import fortinet from "../..//../../assets/fortinet.svg"
import AcceptedRisk_False from "../../../../assets/baseVersion/AcceptedRisk_False.svg"
import sophosLogo from "../../../../assets/sophos.svg";
import sophos_dark from "../../../../assets/sophos-white.svg";
import ubuntu from "../../../../assets/ubuntu.svg";
import ubuntu_dark from "../../../../assets/ubuntu_dark.svg";
import ubuntu_light from "../../../../assets/ubuntu_white.svg";
import Windows_light from "../../../../assets/baseVersion/Windows_light.svg";
import windows_dark from "../../../../assets/baseVersion/Windows_dark.svg"
import WhiteTooltip from "../../../../components/WhiteTooltip";
import redhat_light from "../../../../assets/redhat_light.svg";
import redhat_dark from "../../../../assets/redhat_dark.svg";
import huawei_light from "../../../../assets/huawei-ar21 1.svg";
import mikrotik from "../../../../assets/mikrotik.svg";
import mikrotik_dark from "../../../../assets/mikrotik_dark.svg";
import huawei_dark from "../../../../assets/huawei-dark.svg";
import edgecore_logo from "../../../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../../../assets/apple.svg";
import apple_dark from "../../../../assets/apple_dark.svg";
import dell_logo from "../../../../assets/baseVersion/dell-seeklogo 2.svg";

import syrotech_light from "../../../../assets/syrotech_light.svg";
import syrotech_dark from "../../../../assets/syrotech_dark.svg";

const AssetsFlyout = ({ id: rowId, onRowClick, module, scanSummaryId, parameterType }: any) => {
  const isTemplate =
    parameterType?.toLowerCase() === "template" ||
    parameterType?.toLowerCase() === "custom";
  const [assetsData, setAssetsData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const location = useLocation();
  const { scan_uuid: paramScanUuid } = useParams<{ scan_uuid: string }>();
  
  const { onprem_posture_id: reduxPostureId } = useSelector(
    (state: RootState) => state.MyScanDetails
  );

  const effectiveScanSummaryId = scanSummaryId || reduxPostureId || paramScanUuid;
  console.log(effectiveScanSummaryId, "scan_uuid");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // let module = "";
  //const location = useLocation();
  console.log(location.pathname, "location.pathname");
  // if (location.pathname.includes("onprem/scan")) {
  //   module = "on_premise";
  // } else {
  //   module = "cloud";
  // }

  useEffect(() => {
    const fetchAssets = async () => {
      if (!rowId || !effectiveScanSummaryId) return;

      setIsLoading(true);
      setIsReady(false);

      try {
        const response = await axiosInstance.get(
          `securityscan/scan-assets?module=${module}&parameter_name_id=${rowId}&scan_summary_id=${effectiveScanSummaryId}`
        );

        if (response.data?.data) {
          const formattedAssets = response.data.data.map((asset: any) => ({
            id: asset.id,
            hostname: asset.host_name,
            vendor: asset.vendor,
            model: asset.device_model,
            // Same labels as the review view (Security Posture LogoutputManual): 3 waits for a
            // reviewer, 4 and 5 are a reviewer's answer. 3-5 used to fall through to "not applicable".
            compliance:
              ({ 1: "pass", 0: "fail", 2: "not applicable", 3: "pending review", 4: "manually passed", 5: "manually failed" } as Record<string, string>)[
                String(asset.compliance)
              ] ?? asset.compliance,
            acceptedRisk: asset.accepted_risk,
            device_id: asset.device_id,
            account_id: asset.account_id,
            resources_type: asset.resources_type,
          }));

          setAssetsData(formattedAssets);
          setIsReady(true);
        }
      } catch (error) {
        console.error("Error fetching assets data:", error);
        setAssetsData([]);
      } finally {
        setIsLoading(false);
        setIsReady(true);
      }
    };

    fetchAssets();
  }, [rowId, effectiveScanSummaryId]);

  // Reset isReady when dependencies change
  useEffect(() => {
    setIsReady(false);
  }, [rowId, effectiveScanSummaryId]);

  const columnDefs: ColDef[] = [
    {
      field: "vendor",
      headerName: module == "on_premise" ? "Vendor" : "Resource Type",

      filter: true,
      minWidth: 180,
      width: 250,
      cellRenderer: (params: any) => {
        const value = params.value?.toLowerCase();
        let imgSrc = "";

        if (value === "cisco") {
          imgSrc = Cisco_img;
        } else if (value?.toLowerCase() === "palo alto" || value?.toLowerCase() === "paloalto") {
          imgSrc = isDarkMode ? Paloalto_dark : Paloalto_img;
        } else if (value === "amazon web services") {
          imgSrc = isDarkMode ? AWS_DARK : AWS_img;
        } else if (value === "arista") {
          imgSrc = isDarkMode ? arista_dark : arista_img;
        } else if (value === "juniper") {
          imgSrc = isDarkMode ? juniper_dark : juniper_assets;
        } else if (value === "ubuntu") {
          imgSrc = isDarkMode ? ubuntu_dark : ubuntu_light;
        }
        else if (value === "microsoft") {
          imgSrc = isDarkMode ? windows_dark : Windows_light;
        } else if (value === "debian") {
          imgSrc = isDarkMode ? debian_dark : debian;
        } else if (value === "redhat") {
          imgSrc = isDarkMode ? redhat_dark : redhat_light;
        } else if (value === "huawei") {
          imgSrc = isDarkMode ? huawei_dark : huawei_light;
        } else if (value === "mikrotik") {
          imgSrc = isDarkMode ? mikrotik_dark : mikrotik;
        } else if (value === "edgecore") {
          imgSrc = edgecore_logo;
        } else if (value === "tp-link" || value === "tplink") {
          imgSrc = isDarkMode ? tplink_dark : tplink_light;
        } else if (value === "fortinet") {
          imgSrc = isDarkMode ? fortinet : fortinet;
        } else if (value === "sophos") {
          imgSrc = isDarkMode ? sophos_dark : sophosLogo;
        } else if (value === "apple") {
          imgSrc = isDarkMode ? apple_dark : apple_img;
        } else if (value === "dell") {
          imgSrc = dell_logo;
        } else if (value === "syrotech") {
          imgSrc = isDarkMode ? syrotech_dark : syrotech_light;
        }
        // else if (value === "vendor") {
        //   imgSrc = isDarkMode ? vendor_dark : vendor_img;
        // }

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {imgSrc && (
              params?.value?.toLowerCase() === "huawei" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ width: 100, height: 38, objectFit: "contain", marginRight: 8 }}
                />
              ) : params?.value === "arista" || params?.value === "palo alto" || params?.value === "sophos" || params?.value === "vendor" ? (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ height: 10, marginRight: 8, marginTop: 8 }}
                />
              ) : (
                <img
                  src={imgSrc}
                  alt={value}
                  style={{ height: 20, marginRight: 8, marginTop: 8 }}
                />
              )
            )}
            {module !== "on_premise" && params.data.resources_type}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
      },

    },

    {
      field: module === "on_premise" ? "model" : "account_id",
      headerName: module === "on_premise" ? "OS" : "Account",
      filter: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: (params: any) => (
        <WhiteTooltip title={params.value || ""}>
          <Typography
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </WhiteTooltip>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "hostname",
      headerName: "Host Name",
      filter: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: (params: any) => (
        <WhiteTooltip title={params.value || ""}>
          <Typography
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </WhiteTooltip>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "acceptedRisk",
      headerName: "Risk Accepted",
      filter: true,
      minWidth: 100,
      width: 100,
      cellRenderer: (params: any) => {
        if (isTemplate) {
          return (
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              N/A
            </Typography>
          );
        }
        return params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (
          <img
            src={AcceptedRisk_False}
            alt="warning"
            style={{ height: "20px" }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "compliance",
      headerName: "Compliance",
      filter: true,
      minWidth: 120,
      cellRenderer: (params: any) => {
        let imgSrc;
        let altText;

        switch (params.value) {
          case "pass":
          case 1:
          case "1":
            imgSrc = True_img;
            altText = "Pass";
            break;
          case "fail":
          case 0:
          case "0":
            imgSrc = False_img;
            altText = "Fail";
            break;
          case "manually passed":
            imgSrc = True_img;
            altText = "Manually Passed";
            break;
          case "manually failed":
            imgSrc = False_img;
            altText = "Manually Failed";
            break;
          case "pending review":
            imgSrc = PendingReview_img;
            altText = "Pending Review";
            break;
          case "not applicable":
          case "manual":
          case 2:
          case "2":
            imgSrc = Not_Applicable;
            altText = "Not Applicable";
            break;
          default:
            imgSrc = Not_Applicable;
            altText = "Not Applicable";
        }

        return (
          <WhiteTooltip title={altText}>
            <img
              src={imgSrc}
              alt={altText}
              style={{ width: 20, height: 20 }}
            />
          </WhiteTooltip>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  ];

  return (
    // <div
    //   style={{
    //     height: "calc(90vh - 95px)",
    //     display: "flex",
    //     flexDirection: "column",
    //     overflow: "auto",
    //     scrollbarWidth: "none",
    //   }}
    // >
    <AgGridTable
      columnDefs={columnDefs}
      data={assetsData}
      showSearch
      isRowSelectable
      height={"calc(100vh - 200px)"}
      onRowClick={(row: any) => {
        if (onRowClick) onRowClick(row);
      }}
      isLoading={!isReady || isLoading}
    />
    // </div>
  );
};

export default AssetsFlyout;
